<template>
  <div class="py-2 flex flex-column mt-4 md:mt-0">
    <div class="ml-auto -mt-5 flex align-items-center md:mb-4">
      <div
        v-tooltip.top="
          isPassing
            ? 'All correlation validation values are within recommended ranges'
            : 'A correlation validation value is outside of the recommended range'
        "
      >
        <icon
          :icon="['fas', isPassing ? 'square-check' : 'square-x']"
          size="xl"
          class="mx-3"
        />
      </div>
      <InputSwitch v-model="isVisible" input-id="corr-val" />
      <label for="corr-val" class="ml-2 cursor-pointer"
        >Show Correlation Validations</label
      >
    </div>
    <transition name="vertical-slide">
      <CorrelationChecksTable
        v-show="isVisible"
        stage="intake"
        @update:is-passing="isPassing = $event"
      />
    </transition>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import CorrelationChecksTable from "./CorrelationChecksTable.vue";
import InputSwitch from "primevue/inputswitch";

const isVisible = ref(false);
const isPassing = ref(true);
</script>

<style lang="scss" scoped>
:deep(.fa-square-check) {
  color: var(--success-500);
}
:deep(.fa-square-x) {
  color: var(--danger-500);
}
</style>
